import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [params] = useSearchParams();
  const backTo = params.get("portal") === "admin" ? "/admin" : "/partner";
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email, portal: params.get("portal") || "partner" });
      setSent(true);
    } catch (err) {
      const message = apiError(err);
      setError(message);
      toast.error(message);
    }
  };

  return (
    <div className="flex min-h-screen flex-col justify-center px-6 py-14 text-left sm:px-14">
      <Link to="/" className="mb-10 inline-block">
        <Brand />
      </Link>
      <div className="max-w-sm">
        <h1 className="font-display text-3xl font-bold text-slate-900">Reset your password</h1>
        <Card className="mt-8 border-slate-200">
          <CardContent className="p-7">
            {sent ? (
              <div className="space-y-4" data-testid="forgot-success">
                <p className="text-sm text-slate-600">
                  If that email has an account, a password reset link is on its way. The link expires
                  in one hour.
                </p>
                <Link to={backTo}>
                  <Button variant="outline" className="w-full">
                    Back to sign in
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-5">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email-input"
                  />
                </div>
                {error && (
                  <p
                    className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
                    data-testid="forgot-error"
                  >
                    {error}
                  </p>
                )}
                <Button type="submit" className="w-full" data-testid="forgot-submit-button">
                  Send reset link
                </Button>
                <Link to={backTo} className="block text-center text-xs text-blue-700 hover:underline">
                  Back to sign in
                </Link>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
